import { useTranslation } from 'react-i18next';
import { StyledTableCell, StyledTableRow } from 'components/DataTable/style';
import logixPanelInstance from 'i18n';

const TableHeadRow = (): JSX.Element => {
  const { t } = useTranslation('mla', {
    i18n: logixPanelInstance
  });

  return (
    <StyledTableRow aria-label="table head row">
      <StyledTableCell $width="60px" $stickyLeft="0px">
        {t('no')}
      </StyledTableCell>
      <StyledTableCell
        $stickyLeft="60px"
        $boxShadowPosition="right"
        align="left"
      >
        {t('traderNumber')}
      </StyledTableCell>
      <StyledTableCell align="left">{t('date')}</StyledTableCell>
      <StyledTableCell align="left">{t('email')}</StyledTableCell>
      <StyledTableCell align="left">{t('exp')}</StyledTableCell>
      <StyledTableCell align="left" $clampText>{t('expCompany')}</StyledTableCell>
      <StyledTableCell align="left">{t('oneMonthNewAcc')}</StyledTableCell>
      <StyledTableCell align="left">{t('perMonthTradingVolume')}</StyledTableCell>
      <StyledTableCell align="left">{t('avgDeposit')}</StyledTableCell>
      <StyledTableCell align="left" $clampText>{t('expComment')}</StyledTableCell>
      <StyledTableCell align="left" $clampText>{t('serviceComment')}</StyledTableCell>
      <StyledTableCell
        $width="135px"
        align="left"
      >
        {t('reviewStatus')}
      </StyledTableCell>
      <StyledTableCell $width="120px" align="center">
        {t('action')}
      </StyledTableCell>
      <StyledTableCell $width="120px" align="center">
        {t('comment')}
      </StyledTableCell>
      <StyledTableCell $width="120px" align="center">
        {t('accountStatus')}
      </StyledTableCell>
      <StyledTableCell $width="120px" align="center">
        {t('retry')}
      </StyledTableCell>
    </StyledTableRow>
  );
};

export default TableHeadRow;
